import React from 'react';
import Box from './box';

const InfoBox = props => <Box className="alert-info" alignment={props.alignment}>
  {props.children}
</Box>;
export default InfoBox;
